import { render, staticRenderFns } from "./AdminNavbar.vue?vue&type=template&id=880b0df6&"
import script from "./AdminNavbar.vue?vue&type=script&lang=js&"
export * from "./AdminNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports